// ======================================================================
// File Name       : report
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { hasProperty } from '../utils';
import * as ActionTypes from '../constants/actionTypes/report';
import { MODE } from '../constants';

const INITIAL_STATE = {
  reports: {
    byItemSecernId: {},
    allItemSecernIds: [],
    recordNum: 0,
    startPosition: 0,
  },

  editMode: MODE.EDIT_MODE,

  editingReport: {},
};

export default function report(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.REPORT_RECEIVE_REPORT_LIST: {
      const { startPosition, recordNum, reportList } = action;
      const reports = reportList.reduce(
        (acc, cur) => {
          const { itemSecernId } = cur;
          acc.byItemSecernId[itemSecernId] = cur;
          acc.allItemSecernIds.push(itemSecernId);
          return acc;
        },
        {
          byItemSecernId: {},
          allItemSecernIds: [],
          recordNum,
          startPosition,
        },
      );

      return {
        ...state,
        ...{ reports },
      };
    }

    case ActionTypes.REPORT_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG: {
      const { itemSecernId } = action;
      const editingReport = { ...state.reports.byItemSecernId[itemSecernId] };
      return {
        ...state,
        editMode: MODE.EDIT_MODE,
        editingReport,
      };
    }

    case ActionTypes.REPORT_INIT_DATA_FOR_REPORT_REGISTER_DIALOG: {
      return {
        ...state,
        editMode: MODE.NEW_MODE,
        editingReport: {
          reportDeadline: null,
          reportReturnPlanDate: null,
        },
      };
    }

    case ActionTypes.REPORT_UPDATE: {
      const { payload } = action;
      const editingReport = { ...state.editingReport, ...payload };
      return {
        ...state,
        editingReport,
      };
    }

    default:
      return state;
  }
}
